/**
 * HubSpot Forms API Integration
 * Client-side submission to HubSpot via Next.js API route
 */

const HUBSPOT_PORTAL_ID = '26049307';
const HUBSPOT_FORM_ID = 'dfa12a8e-e7df-4204-9bd5-1ca809eb9d31';

export interface HubSpotFormData {
  firstname: string;
  email: string;
  phone: string;
  company: string;
  business_type: string;
  annual_revenue: string;
  message?: string;
  
  // Attribution & tracking data
  utm_source_first?: string;
  utm_medium_first?: string;
  utm_campaign_first?: string;
  utm_term_first?: string;
  utm_content_first?: string;
  utm_id_first?: string;
  
  utm_source_last?: string;
  utm_medium_last?: string;
  utm_campaign_last?: string;
  utm_term_last?: string;
  utm_content_last?: string;
  utm_id_last?: string;
  
  cta_id?: string;
  cta_position?: string;
  cta_variant?: string;
  
  origin_url?: string;
  referrer_url?: string;
  first_landing_url?: string;
  
  device_category?: string;
  browser_language?: string;
  page_language?: string;
  page_locale?: string;
  
  consent_snapshot?: string;
}

export interface HubSpotSubmitResponse {
  success: boolean;
  error?: string;
  redirectUrl?: string;
}

/**
 * Submit form data to HubSpot via Next.js API route
 * The API route handles reCAPTCHA verification, rate limiting, and honeypot
 */
export async function submitToHubSpot(
  formData: HubSpotFormData,
  recaptchaToken: string,
  honeypot: string = ''
): Promise<HubSpotSubmitResponse> {
  try {
    const response = await fetch('/api/submit-demo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        formData,
        recaptchaToken,
        honeypot,
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.error || 'Er ging iets mis. Probeer het later opnieuw.',
      };
    }
    
    const data = await response.json();
    return {
      success: true,
      redirectUrl: data.redirectUrl,
    };
  } catch (error) {
    console.error('HubSpot submission error:', error);
    return {
      success: false,
      error: 'Netwerkfout. Controleer je internetverbinding en probeer opnieuw.',
    };
  }
}

/**
 * Get HubSpot tracking cookie (hubspotutk) if analytics consent is granted
 */
export function getHubSpotCookie(): string | null {
  if (typeof document === 'undefined') return null;
  
  const match = document.cookie.match(/hubspotutk=([^;]+)/);
  return match ? match[1] : null;
}

